import React from "react";
import "../../../Styles/Modal.css";
import "../../../Styles/reModal.css";
import { ImCancelCircle } from "react-icons/im";

type Product = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: { selling: string };
  quantity: string;
  _id: string;
};

const ProductQuantity = ({
  selectProduct,
  handleProQuanModal,
  sign,
  handleChange,
  setOpPro,
  handleProSelect,
}: any) => {
  const handleProductClose = (product: Product) => {
    setOpPro(false);
    handleProQuanModal();
    handleProSelect(product);
  };

  return (
    <div className="modal">
      <form className="catModal adCus">
        <div className="catModalTop">
          <h4>Add Quantity</h4>
          <ImCancelCircle className="catCancel" onClick={handleProQuanModal} />
        </div>
        <div className="line"></div>

        <div className="catModalInput branchInput qunnt">
          <div className="div modalDouble">
            <div className="proQu ed">
              <label htmlFor="">Product Name</label>
              <input
                type="text"
                placeholder="Product Name"
                name="productName"
                value={selectProduct?.name || ""}
                readOnly
              />
            </div>
            {/* <div className="proQu ed">
              <label htmlFor="">Product Selling Price</label>
              <input
                type="text"
                placeholder="Product Selling Price"
                name="productSellingPrice"
                value={selectProduct?.price?.sellingPrice || ""}
                readOnly
              />
            </div> */}
          </div>
          <div className="div modalDouble">
            <div className="proQu ed">
              <label htmlFor="">Product Quantity</label>
              <input
                type="text"
                placeholder="Enter quantity"
                name="quantity"
                value={sign.quantity || ""}
                onChange={handleChange}
              />
            </div>
            {parseFloat(selectProduct?.quantity || "0") < parseFloat(sign.quantity || "0") && (
              <p className="erh">Product quantity exceeds available quantity</p>
            )}
            <div className="proQu ed"></div>
          </div>
        </div>

        <div className="catModalBtn">
          <button
            type="button"
            className="catBtn1"
            onClick={() => handleProductClose(selectProduct)}
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductQuantity;
